(function(){
    'use strict'

    angular
    .module('app.categorias')
    .controller('categorias.List', List);

    List.$inject = ['$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService'];

    function List($animationsSrv, ApiBaseService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();

        var permisosCategorias = UserInfoService.getPermisosCategorias();

        var vm = this;

        vm.uiData = {
            puedeGuardar: permisosCategorias.guardar === true,
            puedeModificar: permisosCategorias.modificar === true,
            puedeEliminar: permisosCategorias.eliminar === true
        };

        vm.collection = [];
        vm.title = 'Categorias';

        vm.goToEdit = function(data){
            
            var path = '/editar-categoria/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        function getRemoteController()
        {
            return 'api/Categorias/All';
        }

        getAll();

        function getAll(){
            ApiBaseService.remoteController = getRemoteController();
            var promise = ApiBaseService.getAll([]);

            promise
            .then(function(collection){
                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        vm.delete = function(data){
            ApiBaseService.remoteController = 'api/Categorias';
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                vm.collection = vm.collection.filter(function(g) {
                    return g.id !== data.id;
                });
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

    }
})();